
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.693 4.192l.229.01c.48.022 1.832.196 2.7 1.46-2.298 1.493-2.084 4.622.378 5.772-.48 1.395-1.784 3.869-3.276 3.899-.988.018-1.307-.584-2.433-.584s-1.48.566-2.414.602C4.297 15.41 2 11.78 2 8.613c0-2.907 1.889-4.35 3.667-4.374.949-.018 1.85.638 2.43.638.585 0 1.675-.788 2.825-.674zm.244-3.543c.19 1.721-1.351 3.512-2.952 3.386-.201-1.5 1.22-3.314 2.952-3.386z","fill-rule":"evenodd"}})])
          )
        }
      }
    